<template>
  <div v-if="internalValue!==undefined" class="toggle">
    <div v-if="title" class="title">{{ $t(title) }}</div>
    <div class="options">
      <div
        v-for="option in options"
        :key="option.value"
        class="option"
        :class="{active: internalValue===option.value}"
        @click="() => {internalValue = option.value}"
      >
        <div v-if="option.icon" :class="'icon-' + option.icon" />
        <div v-if="option.label" class="option-text">{{ $t(option.label) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'config',
    event: 'change-toggle',
  },
  props: {
    config: [Boolean, String],
    options: Array,
    title: String,
  },
  computed: {
    internalValue: {
      get() {
        return this.config
      },
      set(value) {
        this.$emit('change-toggle', value)
      },
    },
  },
}
</script>

<style lang="stylus" scoped>
.toggle
  margin-bottom: vw(10px)

.title
  m-font-size(14, 20)
  margin-bottom: vw(10px)
  font-weight: 600

.options
  display: flex
  align-items: center
  gap: vw(8px)

.option
  display: flex
  flex: 1 1 0%
  justify-content: center
  align-items: center
  padding: vw(6px) vw(16px)
  outline: 1px solid transparent
  border: 1px solid $grey-grey
  border-radius: 20px
  background-color: white
  cursor: pointer
  gap: vw(6px)

  &:hover
    &:not(.active)
      background-color: $lighter-blue

  &.active
    outline-color: $corporate_color
    border-color: $corporate_color
    background-color: $lighter-blue

    .option-text
      color: $corporate_color

    .icon-horizontal-axis,
    .icon-vertical-axis,
    .icon-skewed-axis,
    .icon-horizontal,
    .icon-vertical,
    .icon-corner-bezier,
    .icon-corner-sharp
      background-color: $corporate_color

.option-text
  m-font-size(14, 20)

.icon-horizontal-axis
  m-icon("horizontal", 16)

.icon-vertical-axis
  m-icon("vertical", 16)

.icon-skewed-axis
  m-icon("diagonal", 16)

.icon-horizontal
  m-icon("orientation-horizontal", 16)

.icon-vertical
  m-icon("orientation-vertical", 16)

.icon-corner-bezier
  m-icon("corner-bezier", 16)

.icon-corner-sharp
  m-icon("corner-sharp", 16)
</style>
